import { BedDouble, Trees, Heart } from "lucide-react";
import { AMENITIES } from "../../data/tilio";
import { Reveal, SectionHeading } from "./Shared";

const ICONS = { BedDouble, Trees, Heart };

export default function Amenities() {
    return (
        <section id="udogodnienia" data-testid="amenities-section" className="border-t border-stone/70 bg-[#F5F8F4]">
            <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    number="02"
                    eyebrow="Udogodnienia"
                    title="Wszystko, czego potrzebujesz"
                    sub="W cenie pobytu — bez gwiazdek i dopłat. W każdym domku i na całej posesji."
                    center
                    testId="amenities-heading"
                />
                <div className="mt-14 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-10">
                    {AMENITIES.map((g, i) => {
                        const Icon = ICONS[g.icon];
                        return (
                            <Reveal key={g.group} delay={i * 0.1}>
                                <div className="flex items-center justify-center gap-3" data-testid={`amenity-group-${i}`}>
                                    <Icon className="h-5 w-5 text-pine" strokeWidth={1.25} />
                                    <h3 className="font-sans text-[18px] font-semibold uppercase tracking-[3px] text-pine">{g.group}</h3>
                                </div>
                                <ul className="mt-6 border-t border-stone">
                                    {g.items.map((item) => (
                                        <li
                                            key={item}
                                            className="border-b border-stone/70 py-3.5 text-center text-[17px] leading-[1.4] text-sage"
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
